import { useTranslation } from 'react-i18next';

import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';

export const ClientItem = ({ clientName }: { clientName?: string | null }) => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return (
    <ProjectPropertiesMenuItem>
      <ProjectPropertiesMenuItemPrefix>
        {t('client')}
      </ProjectPropertiesMenuItemPrefix>
      <ProjectPropertiesMenuItemValue>
        {clientName ?? ''}
      </ProjectPropertiesMenuItemValue>
    </ProjectPropertiesMenuItem>
  );
};
